import React, { useState } from 'react';
import { Modal } from 'antd';
import StickyNote from './StickyNote/StickyNote';
import AudioRecorder from './AudioRecorder/AudioRecorder';
import './RecordingModal.css';

const RecordingModal = ({ open, setOpen, setSelectedId, fetchData, setNewSubmission, setSelectedLanguage }) => {
  // Lift sticky note state here
  const [chiefComplaint, setChiefComplaint] = useState('');
  const [otherNotes, setOtherNotes] = useState('');

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
    setChiefComplaint('');
    setOtherNotes('');
  };

  return (
    <div className="recording-modal">
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title="Record Conversation"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        width="100%"
        centered
        footer={null}
        // Make modal body relative so that absolutely positioned children are relative to it
        bodyStyle={{ position: 'relative' }}
        className="recording-modal"
      >
        {/* Sticky note rendered at the top right corner of the modal */}
        <StickyNote
          chiefComplaint={chiefComplaint}
          setChiefComplaint={setChiefComplaint}
          otherNotes={otherNotes}
          setOtherNotes={setOtherNotes}
        />

        {/* Pass sticky note values down to AudioRecorder */}
        <AudioRecorder 
          setOpen={setOpen} 
          setSelectedId={setSelectedId} 
          fetchData={fetchData} 
          setNewSubmission={setNewSubmission} 
          setSelectedLanguage={setSelectedLanguage}
          chiefComplaint={chiefComplaint}
          setChiefComplaint={setChiefComplaint}
          otherNotes={otherNotes}
          setOtherNotes={setOtherNotes}
        />
      </Modal>
    </div>
  );
};

export default RecordingModal;
